<template>
  <div>
    <v-container fluid grid-list-md>
      <progress-bar></progress-bar>
      <v-toolbar class="mb-4">
        <v-toolbar-title>
          Payable Hours Overview
        </v-toolbar-title>
      </v-toolbar>

      <v-card class="pa-2 mb-2">
        <v-layout row wrap>
          <v-flex xs12 sm6 md2>
            <v-menu
              v-model="menu"
              :return-value="filter.from"
              lazy
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  hide-details
                  v-model="filter.from"
                  label="From"
                  v-on="on"
                  outline
                />
              </template>
              <v-date-picker
                min="2020-01-06"
                locale="ua-ua"
                :first-day-of-week="1"
                v-model="filter.from"
                no-title
                scrollable
              />
            </v-menu>
          </v-flex>
          <v-flex xs12 sm6 md2>
            <v-menu
              v-model="menu2"
              :return-value="filter.to"
              lazy
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  hide-details
                  v-model="filter.to"
                  label="To"
                  v-on="on"
                  outline
                />
              </template>
              <v-date-picker
                min="2020-01-06"
                locale="ua-ua"
                :first-day-of-week="1"
                v-model="filter.to"
                no-title
                scrollable
              />
            </v-menu>
          </v-flex>
          <v-flex xs12 sm6 md3>
            <v-autocomplete
              v-model="filter.users"
              :items="users"
              label="Employees"
              item-text="name"
              item-value="id"
              multiple
              hide-details
              dense
              small-chips
              clearable
              outline
            />
          </v-flex>
          <v-flex xs12 sm6 md3>
            <v-autocomplete
              v-model="filter.projects"
              :items="projects"
              label="Projects"
              item-text="name"
              item-value="id"
              multiple
              hide-details
              dense
              small-chips
              clearable
              outline
            />
          </v-flex>
          <v-flex xs12 sm6 md2>
            <v-btn
              block
              color="info"
              class="ma-0"
              style="height: 100%"
              @click="doFilter"
            >
              Filter
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card>

      <v-layout row wrap>
        <v-flex xs12 sm6>
          <v-card>
            <v-card-text>
              <div v-if="chartLoading" class="text-xs-center">
                <v-progress-circular indeterminate color="success"></v-progress-circular>
              </div>
              <template v-else>
                <transition name="fade">
                  <h3 v-if="!isChartVisible" class="text-xs-center">No data</h3>
                  <sl-chart
                    v-else
                    :chart-data="chartData"
                    :options="chartOptions"
                    type="PieChart"
                  >
                    <template v-if="hasTotalInfo" slot="additional">
                      <table class="ml-auto">
                        <tbody>
                        <tr class="title">
                          <td class="pr-3">Total:</td>
                          <td class="text-xs-right">{{ originalChartData.total_human }}</td>
                        </tr>
                        <tr class="title">
                          <td class="pr-3">Approved for payout:</td>
                          <td class="text-xs-right">{{ originalChartData.approved_for_payout_human }}</td>
                        </tr>
                        </tbody>
                      </table>
                    </template>
                  </sl-chart>
                </transition>
              </template>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import * as mixins from "@/mixins";
import chart from '@/components/reports/chart'
import {mapGetters} from "vuex";

export default {
  name: "PayableHoursReportPage",
  components: {
    'sl-chart': chart
  },
  mixins: [mixins.filter, mixins.preloader],
  data() {
    return {
      api: this.$api.times,
      menu: false,
      menu2: false,
      projects: [],
      users: [],
      filter: {
        users: [],
        projects: [],
        from: '',
        to: ''
      },
      originalChartData: {
        approved: 0,
        invoiced: 0,
        paid: 0,
        logged: 0
      },
      chartData: [
        ['Type', 'Hours', {type: 'string', role: 'tooltip'}],
      ],
      chartLoading: false
    }
  },
  computed: {
    ...mapGetters(['darkTheme']),
    chartOptions () {
      return {
        height: '400',
        pieSliceText: 'label',
        is3D: true,
        slices: [{ color: '#ff8f00' }, { color: '#1bc470' }, { color: '#1c74e8' }, { color: '#a90864' }],
        legend: {
          position: 'right',
          alignment: 'center',
          textStyle: { color: this.darkTheme ? '#fff' : '#000', fontSize: 16 }}
      }
    },
    isChartVisible() {
      return this.originalChartData.approved || this.originalChartData.invoiced || this.originalChartData.paid || this.originalChartData.logged
    },
    hasTotalInfo() {
      return this.originalChartData.total_human && this.originalChartData.approved_for_payout_human
    },
  },
  methods: {
    loadProjects() {
      return this.$api.projects.list({ unlimit: 1 }).then(({ data }) => {
        this.projects = data
      })
    },
    loadUsers() {
      return this.$api.users.list({ unlimit: 1 }).then(response => {
        this.users = response.data.data ? response.data.data : response.data
      })
    },
    getCurrentSprintByDate(date = '') {
      return this.$api.reports.getSprintDates({ from: date, unlimit: 1 }).then(response => {
        this.filter.from = response.data.from
        this.filter.to = response.data.to
      }, (error) => {
        console.error(error)
      })
    },
    getChart() {
      this.chartLoading = true

      let params = {
        from: this.filter.from,
        to: this.filter.to,
        users: this.filter.users,
        projects: this.filter.projects,
        unlimit: 1
      }

      return this.$api.reports.getTimesChartData(params).then(response => {
        const keys = [
          { title: `Logged`, value: 'logged', humanPropertyName: 'logged_human' },
          { title: `Approved`, value: 'approved', humanPropertyName: 'approved_human' },
          { title: `Invoiced`, value: 'invoiced', humanPropertyName: 'invoiced_human' },
          { title: `Paid`, value: 'paid', humanPropertyName: 'paid_human' }
        ]
        this.chartData = [['Type', 'Hours', {type: 'string', role: 'tooltip'}]]
        this.originalChartData = response.data

        keys.forEach(item => {
          this.chartData.push([
            `${item.title} - ${this.originalChartData[item.humanPropertyName]}`,
            response.data[item.value],
            `${item.title}: ${response.data[item.humanPropertyName]}`
          ])
        })
      }).finally(() => {
        this.chartLoading = false
      })
    },
    doFilter() {
      this.getChart()
    }
  },
  watch: {
    filter: {
      handler() {},
      deep: true
    },
  },
  async mounted() {
    let preload = [this.loadProjects(), this.loadUsers(), this.getCurrentSprintByDate()]
    preload.forEach(item => this.background(item))

    await this.getCurrentSprintByDate()
    this.getChart()
  },
}
</script>